import styled from 'styled-components';
import TopAdvice from './TopAdvice';

export default styled(TopAdvice)`
  align-items: center;
  width: 100%;
  background-color: var(--accent700);
  color: var(--white);
  padding: 1.2rem;
  font-weight: 500;
`;
